export { default } from "./ModalService-component";
